<template>
  <div class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0">
    <page-header
      :header-title="'WhatsApp Business API'"
      :header-content="$t('INBOX_MGMT.ADD.GUPSHUP.DESC')"
    />
    <form class="row" @submit.prevent="createChannel()">
      <div class="medium-8 columns">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.API_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: v$.gupshupApiKey.$error }">
          {{ $t('INBOX_MGMT.ADD.GUPSHUP.APIKEY.LABEL') }}
          <input
            v-model.trim="gupshupApiKey"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.GUPSHUP.APIKEY.PLACEHOLDER')
            "
            @blur="v$.gupshupApiKey.$touch"
          />
          <span v-if="v$.gupshupApiKey.$error" class="message">{{
            $t('INBOX_MGMT.ADD.GUPSHUP.APIKEY.ERROR')
          }}</span>
        </label>
      </div>

       <div class="medium-8 columns">
        <label :class="{ error: v$.gupshupApiName.$error }">
          {{ $t('INBOX_MGMT.ADD.GUPSHUP.APPNAME.LABEL') }}
          <input
            v-model.trim="gupshupApiName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.GUPSHUP.APPNAME.PLACEHOLDER')
            "
            @blur="v$.gupshupApiName.$touch"
          />
          <span v-if="v$.gupshupApiName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.GUPSHUP.APPNAME.ERROR')
          }}</span>
        </label>
      </div>
      
      <div class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.GUPSHUP.APINAME')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
//import alertMixin from 'shared/mixins/alertMixin';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

const shouldBeWebhookUrl = (value = '') =>
  value ? value.startsWith('http') : true;

export default {
  components: {
    PageHeader,
  },
  //mixins: [alertMixin],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      //webhookUrl: 'https://api.callpicker.com/chat/webhook',
      webhookUrl: import.meta.env.VITE_CALLPICKER_API +'chat/webhook',
      gupshupApiKey: '',
      gupshupApiName: '',
      chatwootToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations () {
    return {
      channelName: { required },
      webhookUrl: { shouldBeWebhookUrl },
      gupshupApiKey: { required },
      gupshupApiName: { required },
    }
  },
  methods: {
    async createChannel() {
      console.log("createChannel");
      this.v$.$touch();
      /*if (this.v$.$invalid) {
        return;
      }*/

      try {
        console.log("url: "+ this.webhookUrl);
        console.log("gupshupApiKey: "+this.gupshupApiKey);
        console.log("gupshupApiName: "+this.gupshupApiName);
        console.log(this.v$);
        console.log(this.v$.gupshupApiName);
        const apiChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName,
          channel: {
            type: 'api',
            sub_type: 'gupshup',
            webhook_url: this.webhookUrl,
            gupshup_api_key: this.gupshupApiKey,
            gupshup_api_name: this.gupshupApiName
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: apiChannel.id,
          },
        });
      } catch (error) {
        console.log("Error to create inbox");
        console.log(error);
        const apiMessage = typeof error?.message === 'string' ? error.message : '';
        useAlert(apiMessage || this.$t('INBOX_MGMT.ADD.API_CHANNEL.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>